import { KeepAwake } from '@capacitor-community/keep-awake';
import { isPlatform } from '@ionic/react';
import { useEffect } from 'react';
import { logger } from './logger';

export const usePreventScreenLock = (): void => {
  useEffect(() => {
    if (!isPlatform('capacitor')) {
      return;
    }

    if (!KeepAwake) {
      logger.error('KeepAwake does not exist');
      return;
    }

    KeepAwake.keepAwake();
    return () => {
      KeepAwake.allowSleep();
    };
  }, []);
};
